enum Environments {
  test = "test",
  staging = "staging",
  development = "dev",
  production = "production"
}

export const appConfig = {
  version: process.env.VERSION || "DEVELOPMENT",
  env: process.env.NODE_ENV as Environments,
  a11y: process.env.ENABLE_A11Y_REPORT
}

export const isTestEnvironment = appConfig.env === Environments.test
export const isDevEnvironment = appConfig.env === Environments.development
export const isStagingEnvironment = appConfig.env === Environments.staging
export const isProductionEnvironment = appConfig.env === Environments.production

export default appConfig
